// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/modules/providers-list/providers-list.less
// module id = 3853
// module chunks = 0